import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  helpIcon: {
    marginLeft: theme.spacing(.5),
    marginRight: theme.spacing(.5),
    color: theme.palette.text.secondary,
  },
}));
export default styles;